import * as THREE from 'three'

export const MODEL_PATH = '/33.glb'

export const FLOOR_COLOR = new THREE.Color(0x1565c0)
export const HIGHLIGHT_COLOR = new THREE.Color(0x4fc3f7)
export const DEFAULT_COLOR = new THREE.Color(0x808080)
export const GLASS_COLOR = new THREE.Color(0x88ccee)

// Только красные вертикальные панели (Material #10079663 в GLB)
export const FACADE_STRIPE_RED = new THREE.Color('#B85C38')

export const FACADE_MATERIAL_COLORS: Record<string, THREE.Color> = {
  'Material #10079663': FACADE_STRIPE_RED,
}

export const FLOOR_LAYER_MAP: Record<string, number> = {
  '1floor': 9319,
  '2floor': 9320,
  '3floor': 9321,
}

export const GLASS_KEYWORDS = [
  'glass',
  'window',
  'door',
  'окно',
  'дверь',
  'стекл',
  'schuco_aws',
]

export const DRAG_THRESHOLD = 5
